<template>
  <div class="offset-top-2">
    <div class="container-fixed offset-top-2">
      <VButton
        v-if="isBarringShowHistoryAllowed"
        label="barring.show_profile_versions"
        class="btn-brand offset-bottom-2"
        :to="{ name: BARRING_FACTORING_HISTORY }"
      />

      <div v-html="$t('barring.statusInfotext_' + (enableTabs ? 'TypeChoice' : 'NoTypeChoice'))" />
    </div>
    <VTabset v-if="enableTabs" grayed @select:tab="$listeners.select($event.name)">
      <VTab label="barring.profileTypePartner" :active="activeTab === 'partner'" name="partner" :title="$t('barring.profileTypePartnerTitle')">
        <slot v-if="isTypeMismatch" name="confirmation" />
        <slot v-else name="partners" />
      </VTab>
      <VTab label="barring.profileTypeCategory" :active="activeTab === 'category'" name="category" :title="$t('barring.profileTypeCategoryTitle')">
        <slot v-if="isTypeMismatch" name="confirmation" />
        <slot v-else name="categories" />
      </VTab>
    </VTabset>
    <div v-else class="container-fixed offset-bottom-3">
      <slot :name="activeTab === 'partner' ? 'partners' : 'categories'" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTabset from '@/components/UI/Tabs/Tabset';
import VTab from '@/components/UI/Tabs/Tab';
import VButton from '@/components/Button';
import { BARRING_FACTORING_HISTORY } from '@route-types';

export default {
  name: 'BarringFactoringStatusLayout',

  components: {
    VTabset,
    VTab,
    VButton,
  },

  props: {
    enableTabs: {
      type: Boolean,
      required: true,
    },

    profileType: {
      type: String,
      required: true,
      validator: v => ['partner', 'category'].indexOf(v) !== -1,
    },

    activeTab: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      BARRING_FACTORING_HISTORY,
    };
  },

  computed: {
    ...mapGetters('system', ['isBarringShowHistoryAllowed']),

    isTypeMismatch() {
      return this.profileType !== this.activeTab;
    },
  },
};
</script>
